import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { conversationalPreviewSettingsWorkflows } from "./constants";
import type {
  ConversationalPreviewSettingsWorkflowsResult,
  GetConversationalPreviewSettingsWorkflowsProps,
} from "./types";
import { isConversationalPreviewSettingsWorkflowsResult } from "./validators";

/**
 * The saved workflows a settings preview on the selected app or subscription group would route between for the
 * preview user, split by their segment eligibility. Same permissions as the preview itself, since it resolves
 * the preview user and matches their segments.
 */
export const getConversationalPreviewSettingsWorkflows = reactQueryFetcherAdapter(
  conversationalPreviewSettingsWorkflows,
  (
    signal: AbortSignal,
    {
      appGroupId,
      userId,
      appId,
      subscriptionGroupId,
      includeDrafts,
    }: GetConversationalPreviewSettingsWorkflowsProps
  ): Promise<ConversationalPreviewSettingsWorkflowsResult> => {
    return fetch(
      `/${appGroupId}/conversational/preview_settings/workflows`,
      "GET",
      { user_id: userId, app_id: appId, subscription_group_id: subscriptionGroupId, include_drafts: includeDrafts },
      { signal }
    );
  },
  isConversationalPreviewSettingsWorkflowsResult
);
